<script setup>
import { useRouter } from 'vue-router';
import ProjectComments from '@/components/common/ProjectComments.vue';

const router = useRouter();

function goProjectView() {
  router.push({ name: 'ArchitectDashboard' });
}
</script>

<template>
  <ProjectComments/>

  <v-card-actions class="card-actions">
    <v-spacer></v-spacer>
    <v-btn color="secondary" variant="flat" @click="goProjectView">
      {{ $t('backTo') }} {{ $t('titles.dashboard') }}
    </v-btn>
  </v-card-actions>
</template>

<style scoped>
@import '@/assets/styles/views/HomeView.css';
</style>
